import AQLCalculator from '../../components/AQLCalculator';
export default AQLCalculator;
